import { UserType } from '@webclient/shared-types/auth';

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type StateType = {
  isUserAuthenticated: boolean;
  me: UserType | null;
  hasSecureAccount: boolean;
  attemptedToLogin: boolean | null;
};

const initialState: StateType = {
  isUserAuthenticated: false,
  me: null,
  hasSecureAccount: false,
  attemptedToLogin: null,
};

const auth = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUserIsAuthenticated: (
      state,
      action: PayloadAction<StateType['isUserAuthenticated']>,
    ) => {
      state.isUserAuthenticated = action.payload;
    },
    setMe: (state, action: PayloadAction<StateType['me']>) => {
      state.me = action.payload;
    },
    setHasSecureAccount: (
      state,
      action: PayloadAction<StateType['hasSecureAccount']>,
    ) => {
      state.hasSecureAccount = action.payload;
    },
    setAttemptedToLogin: (
      state,
      action: PayloadAction<StateType['attemptedToLogin']>,
    ) => {
      state.attemptedToLogin = action.payload;
    },
  },
});

export const {
  setUserIsAuthenticated,
  setHasSecureAccount,
  setMe,
  setAttemptedToLogin,
} = auth.actions;

export default auth.reducer;
